"use strict";
/**
 * @Description:  环境配置文件（暂不需要）
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/28 上午9:44
 */

let baseURL = "", // 接口地址
  homeURL = "", // 总平台地址
  imgUrl = "";
let host = require("./getHost"); // 获取本机ip

// if (process.env.NODE_ENV == "development") {
//   // 本地调试
//   baseURL = "build";
//   imgUrl = "http://10.96.9.111/download";
// } else if (process.env.NODE_ENV == "deveing") {
//   baseURL = "http://10.96.9.111";
//   imgUrl = "http://10.96.9.111/download";
// } else if (process.env.NODE_ENV == "production") {
//   //
//   baseURL = "http://10.96.9.110";
//   imgUrl = "http://10.96.9.110/download";
// } else if (process.env.NODE_ENV == "testing") {
//   //
//   baseURL = "http://10.96.9.111";
//   imgUrl = "http://10.96.9.111/download";
// } else if (process.env.NODE_ENV == "previous") {
//   //
//   baseURL = "http://10.96.9.110";
//   imgUrl = "http://10.96.9.110/download";
// }

if (process.env.NODE_ENV == "development") {
  // 本地调试
  baseURL = "build";
  imgUrl = "http://10.96.9.111/download";
} else {
  baseURL = window.location.protocol + "//" + window.location.host;
  imgUrl = window.location.protocol + "//" + window.location.host + "/download";
}

module.exports = {
  baseURL,
  homeURL,
  imgUrl
};



// WEBPACK FOOTER //
// ./src/config/config.js